import {Octicon} from '@primer/react/deprecated'
import {clsx} from 'clsx'

import styles from './StatusIcon.module.css'

export type StatusIconProps = {
  iconColor: string
  backgroundColor?: string
  icon: React.ElementType
  size: 12 | 20 | 24
  absolute?: boolean
  backgroundClassName?: string
}

export function StatusIcon({
  iconColor,
  icon,
  size = 12,
  backgroundColor = 'var(--fgColor-onEmphasis)',
  absolute = true,
  backgroundClassName,
}: StatusIconProps) {
  let innerSize
  let margin
  if (size === 12) {
    innerSize = '10px'
    margin = '1px'
  } else if (size === 20) {
    innerSize = '16px'
    margin = '2px'
  } else {
    innerSize = '16px'
    margin = '4px'
  }

  return (
    <div
      className={clsx(
        styles.outerContainer,
        absolute ? styles.outerContainerAbsolute : styles.outerContainerRelative,
        backgroundClassName,
      )}
    >
      <div
        className={styles.innerCircle}
        style={{
          width: innerSize,
          height: innerSize,
          left: margin,
          top: margin,
          backgroundColor,
        }}
      />
      <span className={styles.icon} style={{color: iconColor}}>
        <Octicon icon={icon} size={size} />
      </span>
    </div>
  )
}
